module.exports = __webpack_public_path__ + "img/route_service.395389f1.jpeg";